import { useEffect } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

export const DynamicThemeColor = () => {
  const { colors } = useTheme();

  useEffect(() => {
    // Update theme-color meta tag for mobile browser header
    const updateThemeColor = () => {
      let metaThemeColor = document.querySelector('meta[name="theme-color"]');
      
      if (!metaThemeColor) {
        metaThemeColor = document.createElement('meta');
        metaThemeColor.setAttribute('name', 'theme-color');
        document.head.appendChild(metaThemeColor);
      }
      
      metaThemeColor.setAttribute('content', colors.primary);
    };

    if (colors.primary) {
      updateThemeColor();
    }
  }, [colors.primary]);

  return null;
};

